import React, { PureComponent } from "react"
import styled from "styled-components"
import { SMALLCHAT_PURPLE } from "../components/consts/colors"

const embedHtml = `
  <div id="mc_embed_signup">
    <form action="http://nicer.us14.list-manage.com/subscribe/post?u=018134740cf42b7d8889b8b3b&amp;id=a710d9caa9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">
        <div class="mc-row-one">
          <div class="mc-field-group mc-name">
            <label for="mce-NAME">Name</label>
            <input type="text" value="" name="NAME" class="required" id="mce-NAME">
          </div>
          <div class="mc-field-group mc-company">
            <label for="mce-COMPANY">Company</label>
            <input type="text" value="" name="COMPANY" class="required" id="mce-COMPANY">
          </div>
        </div>
        <div class="mc-row-two">
          <div class="mc-field-group">
            <label for="mce-EMAIL">Email</label>
            <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
          </div>
            <div id="mce-responses" class="clear">
              <div class="response" id="mce-error-response" style="display:none"></div>
              <div class="response" id="mce-success-response" style="display:none"></div>
          </div>
        </div>
        <div style="position: absolute; left: -5000px;" aria-hidden="true">
          <input type="text" name="b_018134740cf42b7d8889b8b3b_fffff31933" tabindex="-1" value="">
        </div>
        <div class="clear">
          <input type="submit" value="Sign Up" name="subscribe" id="mc-embedded-subscribe" class="button">
        </div>
      </div>
    </form>
  </div>
`

const MailchimpStyler = styled.div`
  margin: 20px 0;

  .mc-row-one {
    display: flex;
  }
  .mc-field-group {
    display: flex;
    flex-direction: column;
    label {
      font-size: 12px;
      font-weight: 600;
    }
    input {
      border: none;
      outline: none;
      font-size: 16px;
      height: 36px;
      line-height: 36px;
      border-radius: 8px;
      padding: 0 8px;
      margin: 10px 0 15px;
    }
  }
  .mc-name {
    width: 40%;
    padding-right: 20px;
  }
  .mc-company {
    width: 60%;
  }
  .button {
    margin-top: 15px;
    display: block;
    width: 120px;
    height: 36px;
    border: none;
    outline: none;
    font-size: 16px;
    margin-left: auto;
    line-height: 36px;
    font-weight: 900;
    border-radius: 8px;
    background-color: white;
    -webkit-appearance: none;
    box-shadow: 3px 3px 0 0 ${SMALLCHAT_PURPLE};
    transition: box-shadow 200ms;
    &:hover {
      box-shadow: 5px 5px 0 0 ${SMALLCHAT_PURPLE};
    }
  }
`

export default class MailchimpForm extends PureComponent {
  shouldComponentUpdate() {
    return false
  }

  render() {
    return (
      <MailchimpStyler>
        <div dangerouslySetInnerHTML={{ __html: embedHtml }} />
      </MailchimpStyler>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MailchimpForm.js